/* eslint-disable no-console -- this IS the logger; console is the intended output */
import { faro } from '@/faro_instrument'
import { recordTelemetry } from '@/utils/telemetry'

function createLogger() {
  const shouldLogToConsole = import.meta.env.MODE !== 'production'
  const shouldLogToAgentnoon = !!faro
  const transports = [
    (args, level) => {
      recordTelemetry({ type: 'log', level, args })
    }
  ]

  if (shouldLogToConsole) {
    transports.push((args, _level, consoleFn) => {
      consoleFn(...args)
    })
  }

  if (shouldLogToAgentnoon) {
    transports.push((args, level) => {
      faro.api.pushLog(args.map(String), { level })
    })
  }

  function log(level, consoleFn, args) {
    transports.forEach((transport) => transport(args, level, consoleFn))
  }

  return {
    error: (...args) => log('error', console.error, args),
    warn: (...args) => log('warn', console.warn, args),
    info: (...args) => log('info', console.log, args),
    debug: (...args) => log('debug', console.debug, args)
  }
}

export const logger = createLogger()
